import Swiper, {Navigation, Pagination, Thumbs, Grid, Autoplay, Zoom, Scrollbar} from "swiper";

new Swiper(".specialists-swiper", {
    modules: [Grid, Autoplay],
    slidesPerView: 1.2,
    spaceBetween: 25,
    slidesPerColumn: 1,
    grabCursor: true,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
    speed: 4500,
    breakpoints: {
        576: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1400: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1700: {
            slidesPerView: 3,
            spaceBetween: 40,
        }
    },
});


new Swiper(".reviews-swiper", {
  modules: [Pagination, Navigation, Grid, Autoplay],
  slidesPerView: 1.2,
  spaceBetween: 10,
  grabCursor: true,
  autoplay: {
    delay: 5000,
  },
    navigation: {
        nextEl: '.reviews-swiper .swiper-reviews-button-next',
        prevEl: '.reviews-swiper .swiper-reviews-button-prev',
    },
  breakpoints: {
    576: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1200: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1400: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
      1600: {
          slidesPerView: 3.2,
          spaceBetween: 40,
      }
  },
});

new Swiper(".blog-swiper", {
    modules: [Pagination, Navigation, Grid, Autoplay],
    slidesPerView: 1.2,
    spaceBetween: 10,
    grabCursor: true,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: '.blog-swiper .swiper-btn-next',
        prevEl: '.blog-swiper .swiper-btn-prev',
    },
    breakpoints: {
        576: {
            slidesPerView: 2,
            spaceBetween: 10,
        },
        1200: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1400: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
        1600: {
            slidesPerView: 3.2,
            spaceBetween: 40,
        }
    },
});

new Swiper(".portfolio-swiper", {
    modules: [Pagination, Navigation, Grid, Autoplay],
    slidesPerView: 1,
    spaceBetween: 10,
    grabCursor: true,
    navigation: {
        nextEl: '.portfolio-swiper .swiper-btn-next',
        prevEl: '.portfolio-swiper .swiper-btn-prev',
    },
});

